class ProductInformation extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId
    this.handleEvents();
  }

  connectedCallback() {
    if (this.querySelector(".pinfo-gallery-swiper")) this.initSwiperSlider();
    // if (this.querySelector(".color-options .swiper")) this.initColorOptionsSwiper();
    this.querySelector("pinfo-variant-picker").addEventListener(
      "input",
      this.handleVariantEvent.bind(this)
    );
    
    // Functions for mobile
    if (window.innerWidth < 600) {
    this.loaderPdpMobile();
    // window.handle_mobile_zoom();
    this.initMobileSwiper();
    }
   if (window.innerWidth >= 600) {
      this.loaderPdp();
    this.initImageZoomOnHover();
   }

    
    
    this.setupIntersectionObserver();

    this.initQuantitySelector();
  }


  initQuantitySelector() {
    const qtyWrapper = this.querySelector('[data-quantity-selector]');
    if (!qtyWrapper) return;
    const input = qtyWrapper.querySelector('.qty-input');
    const decreaseBtn = qtyWrapper.querySelector('.decrease');
    const increaseBtn = qtyWrapper.querySelector('.increase');
    decreaseBtn.addEventListener('click', () => {
      let currentVal = parseInt(input.value) || 1;
      if (currentVal > parseInt(input.min || 1)) {
        input.value = currentVal - 1;
        this.dispatchQuantityChange(input.value);
      }
    });
    increaseBtn.addEventListener('click', () => {
      let currentVal = parseInt(input.value) || 1;
      input.value = currentVal + 1;
      this.dispatchQuantityChange(input.value);
    });
    input.addEventListener('input', () => {
      if (input.value < 1) input.value = 1;
      this.dispatchQuantityChange(input.value);
    });
  }

  dispatchQuantityChange(value) {
    this.dispatchEvent(new CustomEvent('quantity-change', {
      detail: { quantity: Number(value) },
      bubbles: true
    }));
  }

  /*
  setupIntersectionObserver() {
    const pdpFormBtns = this.querySelector(".pdp-form-btns");
    let isIntersecting = false;
    const elementTop = this.getBoundingClientRect().top + window.scrollY; // Get element's top offset relative to document

    // IntersectionObserver to check if element is in viewport
    const observer = new IntersectionObserver(
      (entries) => {
        isIntersecting = entries[0].isIntersecting;
        // Update class based on intersection or scroll position
        if (isIntersecting || window.scrollY < elementTop) {
          pdpFormBtns.classList.add("in-viewport");
        } else {
          pdpFormBtns.classList.remove("in-viewport");
        }
      },
      { threshold: 0.1 }
    );

    // Scroll event listener to check if user scrolls above the element
    window.addEventListener("scroll", () => {
      if (window.scrollY < elementTop || isIntersecting) {
        pdpFormBtns.classList.add("in-viewport");
      } else {
        pdpFormBtns.classList.remove("in-viewport");
      }
    });

    observer.observe(this);
  }
  */

  setupIntersectionObserver() {
    const pdpFormBtns = this.querySelector(".pdp-form-btns");
    const targetElement = this.querySelector(".pinfo-form-wrapper");
    let lastScrollY = window.scrollY;

    if (!pdpFormBtns || !targetElement) return;

    window.addEventListener(
      "scroll",
      () => {
        const currentScrollY = window.scrollY;
        const direction = currentScrollY > lastScrollY ? "down" : "up";
        const targetRect = targetElement.getBoundingClientRect();

        if (direction === "down" && targetRect.bottom <= 0) {
          pdpFormBtns.classList.remove("in-viewport");
        }

        else if (
          direction === "up" &&
          targetRect.top < window.innerHeight &&
          targetRect.bottom > 0
        ) {
          pdpFormBtns.classList.add("in-viewport");
        }

        lastScrollY = currentScrollY;
      },
      { passive: true }
    );
  }

  loaderPdp() {
    this.querySelectorAll(".color__variant__btn").forEach((cvBtn) => {
      cvBtn.addEventListener("click", () => {
        document.querySelectorAll(".info-media-image").forEach((e) => {
          e.classList.add("pdp__image_loader"); // add loader
          setTimeout(() => {
            // e.classList.remove("pdp__image_loader"); // remove after 2s
          }, 2000);
        });
      });
    });
  }
  loaderPdpMobile() {
    this.querySelectorAll(".color__variant__btn").forEach((cvBtn) => {
      cvBtn.addEventListener("click", () => {
        document.querySelectorAll(".pdp_media__wrap_sm").forEach((e) => {
          e.classList.add("pdp__image_loader"); // add loader
          setTimeout(() => {
            e.classList.remove("pdp__image_loader"); // remove after 2s
          }, 2000);
        });
      });
    });
  }
  initMobileSwiper() {
    this.mobielSwiper = new Swiper(".pdp-media-sm .swiper", {
      slidesPerView: 1.2,
      spaceBetween: 5,
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
      pagination: {
        el: ".pdp-media-sm .swiper-pagination",
      },
      on: {
        init: function () {
          document.querySelector(".total").textContent = this.slides.length;
          document.querySelector(".current").textContent = this.realIndex + 1;
        },
        slideChange: function () {
          document.querySelector(".current").textContent = this.realIndex + 1;
        },
      },
    });
  }

  initColorOptionsSwiper() {
    this.colorOptionsSwiper = new Swiper(".color-options .swiper", {
      slidesPerView: "auto",
      spaceBetween: 10,
      navigation: {
        nextEl: ".color-options .swiper-button-next",
        prevEl: ".color-options .swiper-button-prev",
      },
      on: {
        init: function () {
          const colorOptions = this.el.closest(".color-options");
          const nextButton = colorOptions.querySelector(".swiper-button-next");
          const prevButton = colorOptions.querySelector(".swiper-button-prev");

          const checkLockClasses = () => {
            if (
              nextButton.classList.contains("swiper-button-lock") &&
              prevButton.classList.contains("swiper-button-lock")
            ) {
              colorOptions.classList.add("no-padding");
            } else {
              colorOptions.classList.remove("no-padding");
            }
          };

          checkLockClasses();

          const observer = new MutationObserver(checkLockClasses);
          observer.observe(nextButton, {
            attributes: true,
            attributeFilter: ["class"],
          });
          observer.observe(prevButton, {
            attributes: true,
            attributeFilter: ["class"],
          });
        },
      },
    });
  }

  initImageZoomOnHover() {
    if (window.innerWidth <= 989) return;

    const imageContainers = this.querySelectorAll(".pdp-media-lg .pdp__image");
    console.log(imageContainers);

    imageContainers.forEach((container) => {
      const img = container.querySelector("img.media");
      // console.log(img)
      if (!img) return;

      img.style.transition = "transform 0.3s ease";

      let isZoomed = false;

      container.addEventListener("click", () => {
        isZoomed = !isZoomed;

        if (isZoomed) {
          container.classList.add("zoomed");
        } else {
          container.classList.remove("zoomed");
          img.style.transformOrigin = "center center";
        }
      });

      container.addEventListener("mousemove", (e) => {
        if (!isZoomed) return;

        const rect = img.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;

        img.style.transformOrigin = `${x}% ${y}%`;
      });

      container.addEventListener("mouseleave", () => {
        isZoomed = false;
        container.classList.remove("zoomed");
        img.style.transformOrigin = "center center";
      });
    });
  }





  handleEvents() {
    this.form = this.querySelector('form[action$="/cart/add"]');
    this.cartDrawer = document.querySelector("cart-drawer");
    this.submitButton = this.querySelector('button[type="submit"]');
    this.submitButtontext = this.submitButton.innerHTML;

    if (this.form) {
      this.form.addEventListener("submit", this.handleAddToCart.bind(this));
    }
  }

  handleVariantEvent(e) {
    const { variantUrl } = e.target.dataset;
    // console.log(variantUrl)
    this.fetchData(variantUrl);
    this.updateURL(variantUrl);
    const variantId = Number(
      new URLSearchParams(variantUrl.split("?")[1]).get("variant")
    );

    // let selectedVariant = productVariants.find((v) => v.id === variantId);

    if (document.querySelector("stock-notify")) {
      // notifyPopup(selectedVariant);
    }
  }

  async fetchData(url) {
    if (this.querySelector("pinfo-variant-picker")) {
      this.querySelector("pinfo-variant-picker").style.pointerEvents = "none";
      this.querySelector("pinfo-variant-picker").style.opacity = "0.7";
    }

    // fetch(
    //   `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.sectionId}`
    // )
    let sectionUrl = `${url}&section_id=${this.sectionId}`
     console.log(url)
      console.log(sectionUrl)
    
    const response = await fetch(sectionUrl);
    // const response = await fetch(url);
    const data = await response.text();
    const html = new DOMParser().parseFromString(data, "text/html");
   
    console.log(html)

    this.renderEl(html);
    window.sizeGuide();
    window.setupHeaderDrawer();
  }

  renderEl(html) {
    // if (this.querySelector(".pinfo-top") && html.querySelector(".pinfo-top")) {
    //   this.querySelector(".pinfo-top").innerHTML =
    //     html.querySelector(".pinfo-top").innerHTML;
    // }

    if (
      this.querySelector(".mobile-only .pinfo-top .pinfo-price-wrapper") &&
      html.querySelector(".mobile-only .pinfo-top .pinfo-price-wrapper")
    ) {
      this.querySelector(
        ".mobile-only .pinfo-top .pinfo-price-wrapper"
      ).innerHTML = html.querySelector(
        ".mobile-only .pinfo-top .pinfo-price-wrapper"
      ).innerHTML;
    }
    if (
      this.querySelector(".desktop-only .pinfo-top .pinfo-price-wrapper") &&
      html.querySelector(".desktop-only .pinfo-top .pinfo-price-wrapper")
    ) {
      this.querySelector(
        ".desktop-only .pinfo-top .pinfo-price-wrapper"
      ).innerHTML = html.querySelector(
        ".desktop-only .pinfo-top .pinfo-price-wrapper"
      ).innerHTML;
    }
    
    // if (this.querySelector(".pinfo-top .pinfo-price-wrapper") && html.querySelector(".pinfo-top .pinfo-price-wrapper")) {
    //   this.querySelector(".pinfo-top .pinfo-price-wrapper").innerHTML =
    //     html.querySelector(".pinfo-top .pinfo-price-wrapper").innerHTML;
    // }
    // if (
    //   this.querySelector("pinfo-variant-picker") &&
    //   html.querySelector("pinfo-variant-picker")
    // ) {
    //   this.querySelector("pinfo-variant-picker").innerHTML = html.querySelector(
    //     "pinfo-variant-picker"
    //   ).innerHTML;
    // }
        const variantPickers = this.querySelectorAll("pinfo-variant-picker");
        const htmlVariantPickers = html.querySelectorAll("pinfo-variant-picker");

        variantPickers.forEach((picker, index) => {
          if (htmlVariantPickers[index]) {
            picker.innerHTML = htmlVariantPickers[index].innerHTML;
          }
        });
            const prices = this.querySelectorAll(".pinfo-price-wrapper");
        const htmlprices = html.querySelectorAll(".pinfo-price-wrapper");

        prices.forEach((price, index) => {
          if (htmlprices[index]) {
            price.innerHTML = htmlprices[index].innerHTML;
          }
        });

    // if (this.querySelector(".color-options .swiper")) this.initColorOptionsSwiper();
    // if (document.querySelector("pqa-new")) {
    //   document.querySelector("pqa-new").innerHTML =
    //     html.querySelector("pqa-new").innerHTML;
    // }
    if (this.querySelector("--inventory-message")) {
      this.querySelector("--inventory-message").innerHTML = html.querySelector(
        "--inventory-message"
      ).innerHTML;
    }

    if (
      this.querySelector(".pinfo-form-wrapper") &&
      html.querySelector(".pinfo-form-wrapper")
    ) {
      this.querySelector(".pinfo-form-wrapper").innerHTML = html.querySelector(
        ".pinfo-form-wrapper"
      ).innerHTML;
    }

    if (
      this.querySelector(".p-model-info") &&
      html.querySelector(".p-model-info")
    ) {
      this.querySelector(".p-model-info").innerHTML =
        html.querySelector(".p-model-info").innerHTML;
    }

    if (
      this.querySelector("product-info-media") &&
      html.querySelector("product-info-media")
    ) {
      this.querySelector("product-info-media").innerHTML =
        html.querySelector("product-info-media").innerHTML;
    }
    if (
      this.querySelector(".--discount-code-container") &&
      html.querySelector(".--discount-code-container")
    ) {
      this.querySelector(".--discount-code-container").innerHTML =
        html.querySelector(".--discount-code-container").innerHTML;
    }

    
    

   

    this.handleEvents();
    window.viewerCountPastDay();
    
    window.notifyButtons();
   

    if (this.querySelector("pinfo-variant-picker")) {
      this.querySelector("pinfo-variant-picker").style.pointerEvents = "unset";
      this.querySelector("pinfo-variant-picker").style.opacity = "1";
    }
    window.setupHeaderDrawer();
    this.setupIntersectionObserver();
    if (window.innerWidth >= 600) {
    this.initImageZoomOnHover();
    this.loaderPdp();
    } else {
      // Mobile Functions
      this.loaderPdpMobile();
      this.initMobileSwiper();
      // window.handle_mobile_zoom();
    }
    window.mblLightBoxFunc();
    yotpoWidgetsContainer.initWidgets();
    window.copyCode();
    // Dispatch variant:change event
    const variantId = this.querySelector('input[name="id"]')?.value;
    if (variantId) {
      // console.log('Dispatching variant:change event with variant ID:', variantId);
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variantId } }));
    }

  }

  updateURL(url) {
    if (typeof url !== "string" || !url.startsWith("/")) {
      console.error("Invalid URL format");
      return;
    }

    if (this.dataset?.updateUrl === "true") {
      window.history.pushState({}, "", url);
    }
  }

  handleAddToCart(e) {
    e.preventDefault();
    
    // Set loading state
    if (this.submitButton) {
      
      this.submitButton.classList.add("loading");
      this.submitButton.innerHTML = '<span class="loader"></span> Adding...';
      this.submitButton.disabled = true;
    }

    const formData = new FormData(this.form);
    const variantId = formData.get("id");

    const qtyInput = this.querySelector('.quantity-selector .qty-input');
    if (qtyInput) {
      formData.set('quantity', qtyInput.value);
    }

    if (this.cartDrawer && this.cartDrawer.getSectionsToRender) {
      formData.append(
        "sections",
        this.cartDrawer.getSectionsToRender().map((section) => section.id)
      );
    }
    formData.append("sections_url", window.location.pathname);

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          if (typeof publish === "function") {
            publish(PUB_SUB_EVENTS.cartError, {
              source: "product-form",
              productVariantId: variantId,
              errors: response.errors || response.description,
            });
          }
          throw new Error(response.errors || response.description);
        }

        if (this.cartDrawer && this.cartDrawer.renderContents) {
          this.cartDrawer.renderContents(response);
        }

        if (this.cartDrawer && this.cartDrawer.open) {
          this.cartDrawer.classList.remove("is-empty");
          this.cartDrawer.open();
        }
        if (productQuickView.container.classList.contains("open")) {
          productQuickView.container.close();
        }

        if (typeof publish === "function") {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: variantId,
          });
        }
      })
      .catch((error) => {
        console.error("Add to cart failed:", error);
      })
      .finally(() => {
        if (this.submitButton) {
          this.submitButton.classList.remove("loading");
          // this.submitButton.textContent = "Add To Cart";
          console.log("submitButtontext",this.submitButtontext)
          this.submitButton.innerHTML = this.submitButtontext;
          this.submitButton.disabled = false;
        }
      });
  }

  initSwiperSlider() {
    if (this.gallerySwiper) this.gallerySwiper.destroy(true, true);
    this.gallerySwiper = new Swiper(".pinfo-gallery-swiper", {
      slidesPerView: 2,
      spaceBetween: 0,
      watchSlidesProgress: true,
    });

    if (this.thumbSwiper) this.thumbSwiper.destroy(true, true);
    this.thumbSwiper = new Swiper(".pinfo-thumb-swiper", {
      slidesPerView: 1,
      thumbs: {
        swiper: this.gallerySwiper,
      },
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const body = document.body;
  const scrollThreshold = 300;
  let isScrolled = false;

  window.addEventListener("scroll", function () {
    const shouldBeScrolled = window.scrollY > scrollThreshold;

    if (shouldBeScrolled !== isScrolled) {
      isScrolled = shouldBeScrolled;
      if (isScrolled) {
        body.classList.add("pad__bottom");
      } else {
        body.classList.remove("pad__bottom");
      }
    }
  });
});

window.initFaqAccordions = function () {
  const faqAccordions = document.querySelectorAll(".pr-faq-item");
  const openFaqAccordion = (accordion) => {
    const content = accordion.querySelector(".pr-faq-content");
    accordion.classList.add("active");
    content.style.maxHeight = content.scrollHeight + "px";
  };

  const closeFaqAccordion = (accordion) => {
    const content = accordion.querySelector(".pr-faq-content");
    accordion.classList.remove("active");
    content.style.maxHeight = null;
  };

  if (faqAccordions.length > 0) {
    openFaqAccordion(faqAccordions[0]);

    faqAccordions.forEach((accordion) => {
      const header = accordion.querySelector(".pr-faq-header");
      const content = accordion.querySelector(".pr-faq-content");

      accordion.onclick = () => {
        if (content.style.maxHeight) {
          closeFaqAccordion(accordion);
        } else {
          faqAccordions.forEach((accordion) => closeFaqAccordion(accordion));
          openFaqAccordion(accordion);
        }
      };
    });
  }
};

document.addEventListener("DOMContentLoaded", function () {
  window.initFaqAccordions();
});

class ProductQuickAdd extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("input", this.handleVariantInput.bind(this));
    this.addEventListener("click", this.handleSubmitEvemt.bind(this));
    this.addEventListener("change", this.handleVariantInput.bind(this));
  }

  handleVariantInput(e) {
    const variantUrl = e.target.value;

    if (variantUrl && document.querySelector("product-information")) {
      const productInfo = document.querySelector("product-information");
      productInfo.fetchData(variantUrl);
      productInfo.updateURL(variantUrl);
    }
  }

  handleSubmitEvemt(e) {
    if (e.target.closest("form")) {
      e.preventDefault();
    }

    if (e.target.tagName === "BUTTON") {
      this.handleAddToCart(e.target.closest("form"), e.target);
    }
  }

  handleAddToCart(form, btn) {
    if (!form) return;

    if (btn) {
      // btn.classList.add("loading");
      btn.textContent = "Adding To Cart ...";
      btn.style.pointerEvents = "none";
      btn.style.opacity = ".7";
    }
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    let formData = new FormData(form);

    const qtyInput = this.querySelector('.quantity-selector .qty-input');
    if (qtyInput) {
      formData.set('quantity', qtyInput.value);
    }

    if (this.cart) {
      formData.append(
        "sections",
        this.cart.getSectionsToRender().map((section) => section.id)
      );
    }
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        this.cart.renderContents(response);
      })
      .finally(() => {
        if (btn) {
          // btn.classList.remove("loading");
          btn.textContent = "Add To Cart";
          btn.style.pointerEvents = "unset";
          btn.style.opacity = "1";
        }
        if (document.querySelector(".new-header-cart-icon"))
          document.querySelector(".new-header-cart-icon").click();

        if (this.cart && this.cart.classList.contains("is-empty"))
          this.cart.classList.remove("is-empty");
        initswiperincart();
      });
  }
}

document.addEventListener("DOMContentLoaded", (e) => {
  customElements.define("product-information", ProductInformation);
  customElements.define("pqa-new", ProductQuickAdd);
});



window.viewerCountPastDay = function () {
  const viewerElement = document.getElementById("viewer-count");

  if (
    !viewerElement ||
    !viewerElement.dataset.productId ||
    !viewerElement.dataset.min ||
    !viewerElement.dataset.max
  ) {
    return;
  }
  const productId = viewerElement.dataset.productId;
  const storageKey = `viewerCount_${productId}`;
  const min = parseInt(viewerElement.dataset.min);
  const max = parseInt(viewerElement.dataset.max);

  function updateViewerCount() {
    const viewerCount = Math.floor(Math.random() * (max - min + 1)) + min;
    const numberElement = document.getElementById("viewer-number");
    if (numberElement) {
      numberElement.textContent = viewerCount;
      localStorage.setItem(storageKey, viewerCount);
      localStorage.setItem(`${storageKey}_timestamp`, new Date().getTime());
    }
  }

  function isSameDayInEST(timestamp) {
    const now = new Date();
    const estOffset = -5 * 60;
    const utc = now.getTime() + now.getTimezoneOffset() * 60000;
    const estNow = new Date(utc + estOffset * 60000);
    const storedDate = new Date(parseInt(timestamp));
    const estStored = new Date(storedDate.getTime() + estOffset * 60000);

    return (
      estNow.getFullYear() === estStored.getFullYear() &&
      estNow.getMonth() === estStored.getMonth() &&
      estNow.getDate() === estStored.getDate()
    );
  }

  function scheduleDailyUpdate() {
    const storedCount = localStorage.getItem(storageKey);
    const storedTimestamp = localStorage.getItem(`${storageKey}_timestamp`);
    const numberElement = document.getElementById("viewer-number");

    if (
      storedCount &&
      storedTimestamp &&
      isSameDayInEST(storedTimestamp) &&
      numberElement
    ) {
      numberElement.textContent = storedCount;
    } else {
      updateViewerCount();
    }

    const now = new Date();
    const estOffset = -5 * 60;
    const utc = now.getTime() + now.getTimezoneOffset() * 60000;
    const estNow = new Date(utc + estOffset * 60000);
    const target = new Date(estNow);
    target.setHours(24, 0, 0, 0);

    if (estNow > target) {
      target.setDate(target.getDate() + 1);
    }

    const msUntilMidnight = target.getTime() - estNow.getTime();

    setTimeout(() => {
      updateViewerCount();
      setInterval(updateViewerCount, 24 * 60 * 60 * 1000);
    }, msUntilMidnight);
  }

  scheduleDailyUpdate();
};

// window.getDeliveryWindow = function () {
//   const today = new Date();

//   const startDate = new Date(today);
//   startDate.setDate(today.getDate() + 4);

//   const endDate = new Date(today);
//   endDate.setDate(today.getDate() + 7);

//   const options = { month: "short", day: "numeric" };

//   const formattedStart = startDate.toLocaleDateString("en-US", options);
//   const formattedEnd = endDate.toLocaleDateString("en-US", options);

//   // return `${formattedStart} - ${formattedEnd}`;
//   const deliveryDateText = `${formattedStart} - ${formattedEnd}`;
//   const deliverySpans = document.querySelectorAll(".--delivery-date");
//   deliverySpans.forEach((span) => {
//     span.textContent = deliveryDateText;
//   });
// };

document.addEventListener("DOMContentLoaded", function () {
  window.viewerCountPastDay();
  // window.getDeliveryWindow();
});


// window.test = function (container) {
//   console.log("Test clicked", container);
//   if (!container) {
//     return;
//   }

//   let currentScale = 1; // Initial scale is 1 (no zoom)
//   let image = container.querySelector("img");

//   if (!image) {
//     return;
//   }

//   console.log("Image clicked", image);
//   let image_slide = image.closest(".swiper-slide");
//   // image_slide.classList.add('--zoomed-slide')
//   // console.log("Slide clicked", image_slide);
//   // Variables to handle double-tap zoom
//   let lastTap = 0;
//   const doubleTapThreshold = 300; // Time in milliseconds between taps
//   const zoomFactor = 2; // Double-tap zoom factor (2x zoom)

//   // Touch events for mobile zoom
//   image.addEventListener("touchstart", handleTouchStart);

//   // Prevent default drag behavior on touch devices
//   // image.addEventListener("dragstart", (e) => e.preventDefault());

//   // Handle double-tap to zoom
//   function handleTouchStart(e) {
//     const currentTime = new Date().getTime();
//     const tapLength = currentTime - lastTap;

//     if (tapLength < doubleTapThreshold && tapLength > 0) {
//       // Double-tap detected, toggle zoom
//       toggleZoom();
//     }

//     lastTap = currentTime;
//   }

//   // Double-tap zoom logic
//   function toggleZoom() {
//     if (currentScale === 1) {
//       // Zoom in 2x on the first double-tap
//       currentScale = zoomFactor;
//       image_slide.classList.add('--zoomed-slide')
//     } else {
//       // Reset to original scale (1x) on the second double-tap
//       currentScale = 1;
//       image_slide.classList.remove('--zoomed-slide')
//     }

//     image.style.transform = `scale(${currentScale})`;
//     image.style.transition = "transform 0.3s ease"; // Smooth zoom transition
//   }
// };




window.mblLightBoxFunc = function () {
  let popupSwiper = null;
  let zoomistInstances = [];

  function createZoomistPopup(activeSlideIndex = 0) {
    const popup = document.getElementById('zoomist-popup');
    const swiperWrapper = popup.querySelector('.swiper-wrapper');

    swiperWrapper.innerHTML = '';
    if (popupSwiper) {
      popupSwiper.destroy(true, true);
      popupSwiper = null;
    }
    zoomistInstances.forEach(({ instance }) => instance.destroy());
    zoomistInstances = [];

    const slides = document.querySelectorAll('.pdp-media-image');
    const imagePromises = [];
    const images = [];
    slides.forEach((slide) => {
      const imgElement = slide.querySelector('img');
      if (!imgElement) return;

      const img = new Image();
      img.src = imgElement.src;
      images.push({ src: imgElement.src, alt: imgElement.alt || '' });
      imagePromises.push(
        new Promise((resolve) => {
          if (img.complete) {
            resolve();
          } else {
            img.onload = resolve;
            img.onerror = resolve;
          }
        })
      );
    });

    const paginationEl = document.querySelector('.zoomist-popup .swiper-pagination');
    const prevEl = document.querySelector('.zoomist-popup .swiper-button-prev');
    const nextEl = document.querySelector('.zoomist-popup .swiper-button-next');
    const counterEl = document.querySelector('.zoomist-popup .swiper-counter');

    if (!paginationEl) console.error('Pagination element not found');
    if (!prevEl) console.error('Previous button not found');
    if (!nextEl) console.error('Next button not found');
    if (!counterEl) console.error('Counter element not found');

    popupSwiper = new Swiper('.zoomist-popup .swiper', {
      slidesPerView: 1,
      spaceBetween: 10,
      initialSlide: activeSlideIndex,
      pagination: { el: paginationEl, clickable: true },
      navigation: { prevEl, nextEl },
      allowTouchMove: true,
      touchRatio: 1,
    });

    Promise.all(imagePromises).then(() => {
      images.forEach((image) => {
        const zoomSlide = document.createElement('div');
        zoomSlide.classList.add('swiper-slide');
        zoomSlide.innerHTML = `
          <figure>
            <div class="zoomist-container" data-zoomist-src="${image.src}">
              <div class="zoomist-wrapper">
                <div class="zoomist-image square">
                  <img src="${image.src}" alt="${image.alt}" decoding="async" />
                </div>
              </div>
            </div>
          </figure>
        `;
        swiperWrapper.appendChild(zoomSlide);

        const container = zoomSlide.querySelector('.zoomist-container');
        let currentScale = 1;
        const zoomistInstance = new Zoomist(container, {
          maxScale: 6,
          minScale: 1,
          bounds: true,
          smooth: true,
          draggable: false,
          wheelable: true,
          pinchable: true,
          on: {
            ready() {
              console.log('Zoomist initialized for slide', zoomistInstances.length);
            },
            zoom(zoomist, scale) {
              currentScale = scale;
              zoomist.options.draggable = scale > 1;
              popupSwiper.allowTouchMove = scale === 1;
              console.log('Zoom scale changed:', scale);
            },
          },
        });
        zoomistInstances.push({ instance: zoomistInstance, currentScale });
      });

      popupSwiper.update();
      updateCounter();

      setTimeout(() => {
        let lastActiveIndex = activeSlideIndex;
        popup.querySelectorAll('.zoomist-container').forEach((el, index) => {
          let lastTap = 0;

          el.addEventListener('touchstart', (e) => e.stopPropagation());
          el.addEventListener('touchend', (e) => {
            if (e.changedTouches.length !== 1) return;
            e.preventDefault();
            const currentTime = Date.now();
            const tapLength = currentTime - lastTap;
            if (tapLength < 300 && tapLength > 0) {
              const rect = el.querySelector('.zoomist-image').getBoundingClientRect();
              const offsetX = e.changedTouches[0].clientX - rect.left;
              const offsetY = e.changedTouches[0].clientY - rect.top;
              const newScale = zoomistInstances[index].currentScale === 1 ? 3 : 1;
              zoomistInstances[index].instance.zoomTo(newScale, { x: offsetX, y: offsetY });
              zoomistInstances[index].currentScale = newScale;
              zoomistInstances[index].instance.options.draggable = newScale > 1;
              popupSwiper.allowTouchMove = newScale === 1;
              console.log('Double-tap zoom to scale:', newScale, 'at', offsetX, offsetY);
            }
            lastTap = currentTime;
          });

          el.addEventListener('click', (e) => {
            const currentTime = Date.now();
            const tapLength = currentTime - lastTap;
            if (tapLength < 300 && tapLength > 0) {
              const rect = el.querySelector('.zoomist-image').getBoundingClientRect();
              const offsetX = e.clientX - rect.left;
              const offsetY = e.clientY - rect.top;
              const newScale = zoomistInstances[index].currentScale === 1 ? 3 : 1;
              zoomistInstances[index].instance.zoomTo(newScale, { x: offsetX, y: offsetY });
              zoomistInstances[index].currentScale = newScale;
              zoomistInstances[index].instance.options.draggable = newScale > 1;
              popupSwiper.allowTouchMove = newScale === 1;
              console.log('Double-click zoom to scale:', newScale, 'at', offsetX, offsetY);
            }
            lastTap = currentTime;
          });
        });

        popupSwiper.on('slideChange', () => {
          const activeIndex = popupSwiper.activeIndex;
          if (lastActiveIndex !== activeIndex && zoomistInstances[lastActiveIndex]) {
            zoomistInstances[lastActiveIndex].instance.reset();
            zoomistInstances[lastActiveIndex].currentScale = 1;
            zoomistInstances[lastActiveIndex].instance.options.draggable = false;
            console.log('Reset zoom for slide', lastActiveIndex);
          }
          if (zoomistInstances[activeIndex]) {
            zoomistInstances[activeIndex].instance.update();
            popupSwiper.allowTouchMove = zoomistInstances[activeIndex].currentScale === 1;
            console.log('Slide changed to', activeIndex, ' - Zoomist updated');
          }
          lastActiveIndex = activeIndex;
          updateCounter();
        });

        if (zoomistInstances[activeSlideIndex]) {
          zoomistInstances[activeSlideIndex].instance.update();
        }
      }, 100);

      popup.classList.add('is-open');
    });

    function updateCounter() {
      if (counterEl) {
        const currentSlide = popupSwiper.activeIndex + 1;
        const totalSlides = images.length;
        counterEl.textContent = `${currentSlide}/${totalSlides}`;
      }
    }
  }

  document.querySelector('.--mobile-full-screen-trigger')?.addEventListener('click', () => {
    const activeSlide = document.querySelector('.pdp-media-sm .swiper .swiper-slide-active');
    const activeSlideIndex = activeSlide ? Array.from(activeSlide.parentNode.children).indexOf(activeSlide) : 0;
    createZoomistPopup(activeSlideIndex);
  });

  // document.querySelectorAll('.mbl-media-zoomer').forEach((image) => {
  //   image.addEventListener('dblclick', (e) => {
  //     e.preventDefault();
  //     const slide = image.closest('.swiper-slide');
  //     const clickedIndex = slide ? Array.from(slide.parentNode.children).indexOf(slide) : 0;
  //     createZoomistPopup(clickedIndex);
  //   });
  // });

  document.querySelector('.zoomist-close')?.addEventListener('click', () => {
    const popup = document.getElementById('zoomist-popup');
    popup.classList.remove('is-open');
    popup.addEventListener('transitionend', function handler() {
      if (popupSwiper) {
        popupSwiper.destroy(true, true);
        popupSwiper = null;
      }
      zoomistInstances.forEach(({ instance }) => instance.destroy());
      zoomistInstances = [];
      popup.removeEventListener('transitionend', handler);
    }, { once: true });
  });
};

window.mblLightBoxFunc();

  window.copyCode = async function(){


       const btn = document.querySelector('.pdp-discount__copy')
    
    if (!btn) return;
    btn.addEventListener('click',async ()=>{

    const root = btn.closest('.pdp-discount');
    const code = root?.dataset?.discount || '';
    const status = root.querySelector('.pdp-discount__status');
   

    try {
      await navigator.clipboard.writeText(code);
      status.classList.remove('hidden');
     
      // Optional: store for later use
      try { localStorage.setItem('last_discount_code', code); } catch {}
    } catch (err) {
      status.textContent = 'Copy blocked';
      console.error(err);
    }

    clearTimeout(btn._t);

    })

    


  }
  window.copyCode();
  document.addEventListener('DOMContentLoaded', function() {
  window.copyCode();
  })